
import validationMixin from './validationMixin'

const GlobalMixins = {
  install(Vue) {
    // Validation helpers mixin
    Vue.mixin(validationMixin)
  }
}

export default GlobalMixins



// WEBPACK FOOTER //
// ./src/globalMixins/index.js